import _ from 'lodash';
import {
  SEARCH_ENGINE,
  SOCIAL_DOMAIN,
  TRACKING_PARAMS,
  UTMMEDIUM_QUERY_PARAMETER,
  UTMSOURCE_QUERY_PARAMETER,
  DEFAULT_ZIPCODE,
  DEFAULT_CITY,
  DEFAULT_STATE,
  COOKIE_EXPIRY_WITH_SESSION,
  AI_SEARCH_ENGINE,
  FORMS
} from '../constants/defaults';
import routes from '../constants/route.json';

import { getIpAddress } from '../services/Api/SearchBar/SearchBarService';
import store from '../store';

_.mixin({
  /**
   * Find index of a given form in drug structure data.
   * @param {Object} drugStructure - Response of DrugStructure API.
   * @param {string} form - The form selected from drop-down/code. {ex: "Tablet"} {default: ""}
   * @returns {Number} - Returns the index of given form.
   */
  findFormIndex: (drugStructure = {}, brandId = 0, form = '') => {
    let formIndex = 0;
    if (_.isEmpty(drugStructure) || _.isEmpty(form)) {
      formIndex = -1;
    }

    formIndex = _.findIndex(drugStructure[brandId].forms, {
      Value: form
    });

    return formIndex === -1 ? 0 : formIndex;
  },

  /**
   * Find index of a given dosage in drug structure data.
   * @param {Object} drugStructure - Response of DrugStructure API. {default: {}}
   * @param {string} formIndex - The index of form this dosage belings to.  {ex: 0} {default: -1}
   * @param {string} dosage - The dosage selected from drop-down/code.  {ex: "10MG"} {default: ""}
   * @returns {Number} - Returns the index of given dosage.
   */
  findDosageIndex: (
    drugStructure = {},
    brandId = 0,
    formIndex = 0,
    dosage = ''
  ) => {
    let dosageIndex = 0;
    if (_.isEmpty(drugStructure) || formIndex === -1 || _.isEmpty(dosage)) {
      dosageIndex = -1;
    }

    dosageIndex = _.findIndex(drugStructure[brandId].forms[formIndex].dosages, {
      Value: dosage
    });
    return dosageIndex === -1 ? 0 : dosageIndex;
  },

  /**
   * Find index of a given quantity in drug structure data.
   * @param {Object} drugStructure - Response of DrugStructure API. {default: {}}
   * @param {string} formIndex - The index of form this dosage belings to.  {ex: 0} {default: -1}
   * @param {string} dosageIndex - The dosage selected from drop-down/code.  {ex: 0} {default: -1}
   * @param {string} quantity - The quantity selected from drop-down/code.  {ex: "30"} {default: ""}
   * @returns {Number} - Returns the index of given dosage.
   */
  findQuantityIndex: (
    drugStructure = {},
    brandId = 0,
    formIndex = 0,
    dosageIndex = 0,
    quantity = ''
  ) => {
    let quantityIndex = 0;
    if (
      _.isEmpty(drugStructure) ||
      formIndex === -1 ||
      dosageIndex === -1 ||
      _.isEmpty(quantity)
    ) {
      quantityIndex = -1;
    }

    quantityIndex = _.findIndex(
      drugStructure[brandId].forms[formIndex].dosages[dosageIndex].quantities,
      {
        value: quantity
      }
    );
    return quantityIndex === -1 ? 0 : quantityIndex;
  },

  /**
   * Find index of a given form in drug structure data.
   * @param {Object} brandTypes - Response of DrugStructure API.
   * @param {Object} obj - The object of brand selected from drop-down/code
   */
  findConsolidatedBrandIndex: (brandTypes = [], obj = {}) => {
    let brandId = 0;
    if (_.isEmpty(brandTypes) || _.isEmpty(obj)) {
      brandId = -1;
    }

    brandId = _.findIndex(brandTypes, obj);
    return brandId === -1 ? 0 : brandId;
  },

  /**
   * Find index of a given form in drug structure data.
   * @param {Object} drugStructure - Response of DrugStructure API.
   * @param {string} formName - The name of form selected from drop-down/code. {ex: "Tablet"} {default: ""}
   */
  findConsolidatedFormIndex: (formTypes = [], formName = '') => {
    let formIndex = 0;
    if (_.isEmpty(formTypes) || _.isEmpty(formName)) {
      formIndex = -1;
    }

    formIndex = _.findIndex(formTypes, {
      name: formName
    });

    return formIndex === -1 ? 0 : formIndex;
  },

  /**
   * Find index of a given form in drug structure data.
   * @param {Object} drugStructure - Response of DrugStructure API.
   * @param {string} formName - The name of form selected from drop-down/code. {ex: "Tablet"} {default: ""}
   */
  findConsolidatedDosageIndex: (dosageTypes = {}, dosage = '') => {
    let dosageIndex = 0;
    if (_.isEmpty(dosageTypes) || _.isEmpty(dosage)) {
      dosageIndex = -1;
    }

    dosageIndex = _.findIndex(dosageTypes, {
      dosage
    });
    return dosageIndex === -1 ? 0 : dosageIndex;
  },

  /**
   * Find index of a given form in drug structure data.
   * @param {Object} quantityTypes - Response of DrugStructure API.
   * @param {string} quantityName - The name of form selected from drop-down/code. {ex: "Tablet"} {default: ""}
   */
  findConsolidatedQuantityIndex: (quantityTypes = [], quantity = '') => {
    let quantityIndex = 0;
    if (_.isEmpty(quantityTypes) || _.isEmpty(quantity)) {
      quantityIndex = -1;
    }
    if (typeof quantity == 'string') quantity = parseInt(quantity);

    quantityIndex = _.findIndex(quantityTypes, {
      displayQuantity: quantity
    });
    return quantityIndex === -1 ? 0 : quantityIndex;
  },

  /**
   * Find index of a given form in drug structure data.
   * @param {Object} quantityTypes - Response of DrugStructure API.
   * @param {string} quantityName - The name of form selected from drop-down/code. {ex: "Tablet"} {default: ""}
   */
  CheckCustomQuantityIndex: (quantityTypes = [], quantity = '') => {
    let quantityIndex = 0;
    if (_.isEmpty(quantityTypes) || _.isEmpty(quantity)) {
      quantityIndex = -1;
    }
    if (typeof quantity == 'string') quantity = parseInt(quantity);

    quantityIndex = _.findIndex(quantityTypes, {
      displayQuantity: quantity
    });
    return quantityIndex;
  },

  /**
   * Find index of a given dosage in drug structure data.
   * @param {Object} drugStructure - Response of DrugStructure API. {default: {}}
   * @param {Number} brandId - The index of brand to parse. {ex: 0} {default: 0}
   * @param {Number} formId - The index of form to parse. {ex: 0} {default: 0}
   * @param {Number} dosageId - The index of dosage to parse. {ex: 0} {default: 0}
   * @param {Number} quantity - The index of quantity to parse. {ex: 0} {default: 0}
   * @returns {Object} Value - All the Drug Structure details correlating combination of parameter.
   * @returns {Array} brandTypes - All the brands available in the given drugStructure.
   * @returns {Array} formTypes - All the forms available in the given drugStructure.
   * @returns {Array} dosageData - All the dosages (include quantities) available in the given drugStructure.
   */

  parseDrugStructureData: (
    drugStructure = {},
    brandId = 0,
    formId = 0,
    dosageId = 0,
    quantityId = 0
  ) => {
    // select default first element  value
    if (brandId === -1) brandId = 0;
    if (formId === -1) brandId = 0;
    if (dosageId === -1) dosageId = 0;
    if (quantityId === -1) quantityId = 0;

    const { drug } =
      drugStructure[brandId].forms[formId].dosages[dosageId].quantities[
        quantityId
      ];

    const brandTypes = _.map(drugStructure, brandInfo => {
      return {
        brand: brandInfo.value,
        seoname: brandInfo.forms[0].dosages[0].quantities[0].drug.seoName,
        isGeneric: brandInfo.forms[0].dosages[0].quantities[0].drug.isGeneric,
        ndc: brandInfo.forms[0].dosages[0].quantities[0].drug.ndc,
        quantity: brandInfo.forms[0].dosages[0].quantities[0].drug.quantity
      };
    });
    const formTypes = _.map(drugStructure[brandId].forms, formInfo => {
      return formInfo.Value;
    });
    const dosageData = _.map(
      drugStructure && drugStructure[brandId].forms[formId].dosages,
      dosage => {
        const quantities = _.map(dosage.quantities, quantity => {
          return {
            quantity: quantity.drug.quantity,
            ndc: quantity.drug.ndc,
            displayQuantity: quantity.drug.displayQuantity
          };
        });
        return {
          dosage: dosage.Value,
          quantities
        };
      }
    );

    const doNotMarket = !_.isEmpty(
      drugStructure[brandId].forms[formId].dosages[dosageId].quantities[
        quantityId
      ].drug.deaClassCode
    );

    const isGeneric =
      drugStructure[brandId].forms[formId].dosages[dosageId].quantities[
        quantityId
      ].drug.isGeneric;

    return {
      drug,
      brandTypes,
      formTypes,
      dosageData,
      doNotMarket,
      dosageId,
      isGeneric
    };
  },

  /**
   * Show Header and SiteFooter component based on the location.pathname.
   * @returns {Boolean} - True if it should be shown, false if not.
   */
  isHeaderAndFooterVisible: pathname => {
    if (
      pathname === '/terms-and-conditions' ||
      pathname === '/member-center' ||
      pathname === '/es/member-center' ||
      pathname.startsWith('/member-center') ||
      (!routes.hideHeaderFooter.includes(pathname) &&
        pathname.match(/providers|member|blog/) == null)
    ) {
      return true;
    }
    return false;
  },

  /**
   * Show Header component based on the location.pathname.
   * @returns {Boolean} - True if it should be shown, false if not.
   */

  isHeaderVisible: pathname => {
    if (pathname !== '/lp/florence-health') {
      return true;
    }
    return false;
  },

  isNewFooter: pathname => {
    if (routes.newFooter.includes(pathname)) {
      return true;
    }
    return false;
  },

  isHeaderForLandingPage: pathname => {
    if (routes.headerForLandingPage.includes(pathname)) {
      return false;
    }
    return true;
  },

  parsePriceValue(price = {}) {
    if (
      !_.isEmpty(price.ExclusivePriceDetails) &&
      price.ExclusivePriceDetails.ShowsExclusivePriceAsBaselinePrice
    )
      return (
        Number(price.LoyaltyPrice) +
        Number(price.ExclusivePriceDetails.Modifier)
      ).toFixed(2);
    else return Number(price.LoyaltyPrice).toFixed(2);
  },

  saveRecentlyViewedDrugs(seoName, drugName) {
    const recentDrugs = JSON.parse(localStorage.getItem('RecentlyViewedDrugs'));
    const recentlyViewedDrugs = _.isEmpty(recentDrugs) ? [] : recentDrugs;
    try {
      if (!_.isEmpty(recentlyViewedDrugs)) {
        if (recentlyViewedDrugs.length === 8) {
          if (
            _.isEmpty(
              _.find(recentlyViewedDrugs, { SeoName: seoName, Name: drugName })
            )
          ) {
            recentlyViewedDrugs.shift();
            recentlyViewedDrugs.push({ SeoName: seoName, Name: drugName });
            localStorage.setItem(
              'RecentlyViewedDrugs',
              JSON.stringify(recentlyViewedDrugs)
            );
          }
        } else {
          if (
            _.isEmpty(
              _.find(recentlyViewedDrugs, { SeoName: seoName, Name: drugName })
            )
          ) {
            recentlyViewedDrugs.push({ SeoName: seoName, Name: drugName });
            localStorage.setItem(
              'RecentlyViewedDrugs',
              JSON.stringify(recentlyViewedDrugs)
            );
          }
        }
      } else {
        if (
          _.isEmpty(
            _.find(recentlyViewedDrugs, { SeoName: seoName, Name: drugName })
          )
        ) {
          recentlyViewedDrugs.push({ SeoName: seoName, Name: drugName });
          localStorage.setItem(
            'RecentlyViewedDrugs',
            JSON.stringify(recentlyViewedDrugs)
          );
        } else {
          _.remove(recentlyViewedDrugs, { SeoName: seoName, Name: drugName });
          recentlyViewedDrugs.push({ SeoName: seoName, Name: drugName });
          localStorage.setItem(
            'RecentlyViewedDrugs',
            JSON.stringify(recentlyViewedDrugs)
          );
        }
      }
    } catch (err) {
      console.log('err:', err);
    }
  },

  // Function to check if domain matches exactly or is a subdomain
  matchDomain(url, list) {
    try {
      const domain = new URL(url).hostname;
      // Extract only the domain (e.g., "google.com")
      return list.some(
        engine => domain === engine || domain.endsWith(`.${engine}`)
      );
    } catch (error) {
      return false; // Return false if URL is invalid
    }
  },

  utmTrack(isFromTv = false) {
    const socialDomains = SOCIAL_DOMAIN,
      searchEngines = SEARCH_ENGINE,
      trackingParams = TRACKING_PARAMS,
      AISearchEngines = AI_SEARCH_ENGINE;
    let cookieValue = '',
      socialReferrer,
      searchEngineReferrer,
      aiSearchEngineReferrer;
    const domainReferrer = document.referrer;
    const url_string = window.location.href;
    const url = new URL(url_string);
    const utmSource = url.searchParams.get(UTMSOURCE_QUERY_PARAMETER);
    const utmMedium = url.searchParams.get(UTMMEDIUM_QUERY_PARAMETER);
    if (utmSource || utmMedium) {
      for (let i = 0; i < trackingParams.length; i++) {
        const name = trackingParams[i];
        const val = url.searchParams.get(name.replace('=', ''))
          ? url.searchParams.get(name.replace('=', ''))
          : '';
        if (!_.isEmpty(val)) {
          trackingParams[i] += val;
        }
      }
      //Check if utmSource belongs to an AI search engine
      if (utmSource === 'chatgpt.com') {
        trackingParams[2] = 'utm_source=ai-search';
      }
    } else {
      if (!_.isEmpty(domainReferrer)) {
        /// Check if domainReferrer belongs to a social media site
        socialReferrer =
          _.matchDomain(domainReferrer, socialDomains) &&
          !_.matchDomain(domainReferrer, AISearchEngines);

        // Check if domainReferrer belongs to a search engine (excluding AI search engines)
        searchEngineReferrer =
          _.matchDomain(domainReferrer, searchEngines) &&
          !_.matchDomain(domainReferrer, AISearchEngines);

        // Check if domainReferrer belongs to an AI search engine
        aiSearchEngineReferrer = _.matchDomain(domainReferrer, AISearchEngines);

        if (socialReferrer) {
          trackingParams[2] = 'utm_source=social';
        } else if (searchEngineReferrer) {
          trackingParams[2] = 'utm_source=organic';
        } else if (domainReferrer.match('singlecare.com')) {
          trackingParams[2] = 'utm_source=direct';
        } else if (aiSearchEngineReferrer) {
          trackingParams[2] = 'utm_source=ai-search';
        } else {
          trackingParams[2] = 'utm_source=referral';
        }
        trackingParams[1] = 'utm_medium=singlecare';
      } else {
        for (let i = 0; i < trackingParams.length; i++) {
          const name = trackingParams[i];
          const val = url.searchParams.get(name.replace('=', ''))
            ? url.searchParams.get(name.replace('=', ''))
            : '';
          if (!_.isEmpty(val)) {
            trackingParams[i] += val;
          }
        }
        trackingParams[1] = 'utm_medium=singlecare';
        trackingParams[2] = 'utm_source=direct';
      }
    }
    if (url_string.split('#')[1] === 'fw') {
      sessionStorage.setItem('showFWBanner', 'true');
      trackingParams[1] = 'utm_medium=referral';
      trackingParams[2] = 'utm_source=familywize-sc';
    }
    if (isFromTv) {
      trackingParams[1] = 'utm_medium=tv';
      trackingParams[2] = 'utm_source=tvcampaign';
    }
    cookieValue = trackingParams.join('|');
    _.setCookie('_utmz_custom', cookieValue, COOKIE_EXPIRY_WITH_SESSION);
  },

  getUTMParams: () => {
    const utmzCookie = _.getCookie('_utmz_custom');
    const utmzCookies = utmzCookie.split('|');
    const source = utmzCookies[2].split('=')[1] || null,
      medium = utmzCookies[1].split('=')[1] || null,
      cgn = utmzCookies[0].split('=')[1] || null;
    let utmParams = {
      src: source,
      med: medium,
      cgn: cgn
    };
    return utmParams;
  },
  /**
   * Retrieves Google Analytics 4 tracking parameters.
   *
   * This function extracts the Google Analytics 4 User Pseudo ID and Session ID
   * from cookies and returns them as an object.
   *
   * @returns {Object} An object containing the following properties:
   * - Ga4UserPsuedoId: A string representing the Google Analytics 4 User Pseudo ID.
   * - Ga4SessionId: A string representing the Google Analytics 4 Session ID.
   */
  getGATrackingParams: () => {
    const _ga = _.getCookie('_ga')?.split('.');
    const _ga_V1EVNYS7TH = _.getCookie('_ga_V1EVNYS7TH')?.split('.');
    let Ga4UserPsuedoId = '',
      Ga4SessionId = '';
    if (_ga)
      Ga4UserPsuedoId = _ga?.[2] && _ga?.[3] ? `${_ga[2]}.${_ga[3]}` : null;
    if (_ga_V1EVNYS7TH) Ga4SessionId = _ga_V1EVNYS7TH?.[2] || null;
    let gaParams = {
      Ga4UserPsuedoId: Ga4UserPsuedoId,
      Ga4SessionId: Ga4SessionId
    };
    return gaParams;
  },

  /**
   * Set default location..
   */
  setDefaultLocation: () => {
    const defaultLocation = {
      city: DEFAULT_CITY,
      state: DEFAULT_STATE,
      zipCode: DEFAULT_ZIPCODE
    };
    localStorage.setItem('zipCodeData', JSON.stringify(defaultLocation));
    return defaultLocation;
  },

  /**
   * getLocation
   */
  getLocation: () => {
    if (localStorage.getItem('zipCodeData')) {
      const { zipCode, zip, PostalCode } = JSON.parse(
        localStorage.getItem('zipCodeData')
      );
      return zipCode ? zipCode : zip || PostalCode;
    } else {
      return DEFAULT_ZIPCODE;
    }
  },

  /**
   * get LowestPrice..
   */
  getLowestPrice(tieredPricingData) {
    let min = (a, f) => a.reduce((m, x) => (+m[f] < +x[f] ? m : x));
    const { PharmacyPricings } = tieredPricingData;
    let priceArray = [];
    if (PharmacyPricings) {
      for (let i = 0; i < PharmacyPricings.length; i++) {
        if (!_.isEmpty(PharmacyPricings[i].Prices)) {
          for (let j = 0; j < PharmacyPricings[i].Prices.length; j++) {
            let elem = {
              name: PharmacyPricings[i].Pharmacy.Name,
              price: _.parsePriceValue(PharmacyPricings[i].Prices[j])
            };
            priceArray.push(elem);
          }
        }
      }
    }
    return !_.isEmpty(priceArray) ? min(priceArray, 'price') : 0;
  },

  /**
   * set LowestPrice..
   */
  // setLowestPriceInTreatment: (
  //   treatment,
  //   lowestPrice,
  //   priceUsualAndCustomary
  // ) => {
  //   if (treatment && treatment.includes("${{lowest_sc}}")) {
  //     treatment = treatment.replace(
  //       new RegExp(
  //         "${{lowest_sc}}".replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
  //         "g"
  //       ),
  //       "$" + lowestPrice
  //     );
  //   }
  //   if (
  //     treatment &&
  //     treatment.includes("${{PriceUsualAndCustomary}}") &&
  //     priceUsualAndCustomary
  //   ) {
  //     treatment = treatment.replace(
  //       new RegExp(
  //         "${{PriceUsualAndCustomary}}".replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
  //         "g"
  //       ),
  //       "$" + priceUsualAndCustomary
  //     );
  //   }
  //   return treatment;
  // },

  /**
   * set SeoVariables..
   */
  setSEOVariables: (text, lowestPrice, replaceableVariables) => {
    if (text && text.includes('${{lowest_sc}}')) {
      text = text.replace(
        new RegExp(
          '${{lowest_sc}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
          'g'
        ),
        `$${_.parseApiPrice(lowestPrice)}`
      );
    }
    if (
      text &&
      text.includes('${{PriceUsualAndCustomary}}') &&
      replaceableVariables &&
      replaceableVariables.priceUsualAndCustomary
    ) {
      text = text.replace(
        new RegExp(
          '${{PriceUsualAndCustomary}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
          'g'
        ),
        `$${_.parseApiPrice(replaceableVariables.priceUsualAndCustomary)}`
      );
    }
    if (
      text &&
      text.includes('{{PackageSize}}') &&
      replaceableVariables &&
      replaceableVariables.qty
    ) {
      text = text.replace(
        new RegExp(
          '{{PackageSize}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
          'g'
        ),
        replaceableVariables.qty
      );
    }
    if (
      text &&
      text.includes('{{Dosage}}') &&
      replaceableVariables &&
      replaceableVariables.dosage
    ) {
      text = text.replace(
        new RegExp('{{Dosage}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
        replaceableVariables.dosage
      );
    }
    if (
      text &&
      text.includes('{{Form}}') &&
      replaceableVariables &&
      replaceableVariables.form
    ) {
      text = text.replace(
        new RegExp('{{Form}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'),
        replaceableVariables.form
      );
    }
    return text;
  },

  parseApiPrice: apiPrice => {
    return `$${
      Number(apiPrice) > 1000
        ? apiPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        : Number(apiPrice).toFixed(2)
    }`;
  },

  findStructureFromValues: (
    drugStructures = [],
    brand = '',
    form = '',
    dosage = '',
    quantity = ''
  ) => {
    const brandId = _.findIndex(drugStructures, { value: brand });
    if (brandId !== -1) {
      const formId = _.findIndex(drugStructures[brandId].forms, {
        Value: form
      });

      if (formId !== -1) {
        const dosageId = _.findIndex(
          drugStructures[brandId].forms[formId].dosages,
          { Value: dosage }
        );

        if (dosageId !== -1) {
          const quantityId = _.findIndex(
            drugStructures[brandId].forms[formId].dosages[dosageId].quantities,
            quantityData => {
              return (
                quantityData.value === quantity ||
                quantityData.value === quantity.toString()
              );
            }
          );

          return {
            brandId,
            formId,
            dosageId,
            quantityId: quantityId === -1 ? 0 : quantityId
          };
        }

        return {
          brandId,
          formId,
          dosageId: 0,
          quantityId: 0
        };
      }
      return {
        brandId,
        formId: 0,
        dosageId: 0,
        quantityId: 0
      };
    }

    return {
      brandId: 0,
      formId: 0,
      dosageId: 0,
      quantityId: 0
    };
  },

  triggerIntellimize: () => {
    let intervalId = setInterval(() => {
      if (window.intellimize) {
        clearInterval(intervalId);
        // window.intellimize.activate();
      }
    }, 500);
  },

  sendIntellimizeEvent: (eventName, value = {}) => {
    try {
      window.intellimize.sendEvent(eventName, value);
    } catch (e) {
      console.log('err:', e);
    }
  },

  triggerGTMPageEvent: () => {
    /*let timeInterval = 3000;
    if (document.URL.includes("/prescription/")) timeInterval = 8000;*/
    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Pageview',
        pagePath: document.URL,
        pageTitle: document.title
      });
    }, 1500);
  },

  getLocationDataForGTM: async () => {
    const { city, state, City, zipCode } = JSON.parse(
      localStorage.getItem('zipCodeData')
    );
    let shareLocation = false;
    let ipAddress;
    navigator.permissions &&
      navigator.permissions
        .query({ name: 'geolocation' })
        .then(function (PermissionStatus) {
          if (PermissionStatus.state === 'granted') shareLocation = true;
        });

    if (_.isEmpty(_.getCookie('ipAddress'))) {
      ipAddress = await getIpAddress();
    } else {
      ipAddress = _.getCookie('ipAddress');
    }
    return {
      locationZip: zipCode,
      locationCity: city || City,
      locationState: state,
      shareLocation: shareLocation,
      ipAddress: ipAddress
    };
  },

  triggerGTMVirtualPageViewEvent: async params => {
    let locationData = await _.getLocationDataForGTM();
    let convertedParams = _.numToStringForKeys(params, [
      'authNumber',
      'grpNumber',
      'NDC',
      'GPI',
      'locationZip'
    ]);

    if (params?.drugQuantity && typeof params?.drugQuantity === 'string') {
      convertedParams['drugQuantity'] = parseFloat(params.drugQuantity);
    }

    let eventObj = {
      ...params,
      ...convertedParams,
      ...locationData,
      pagePath: params.pagePath ? params.pagePath : document.URL,
      pageTitle: params.pageTitle ? params.pageTitle : document.title,
      loggedIn: store.getState()?.authentication?.isLoggedIn || false
      //memberId: _.getCookie('mprospect-id'),
      //prospectId: _.getCookie('prospect-id')
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventObj);
  },

  getDefaultDrug: (drugStructure, defaultStructure) => {
    for (let i = 0; i < drugStructure.length; i++) {
      if (drugStructure[i].value === defaultStructure.name) {
        for (let j = 0; j < drugStructure[i].forms.length; j++) {
          if (drugStructure[i].forms[j].Value === defaultStructure.form) {
            for (let k = 0; j < drugStructure[i].forms[j].dosages.length; k++) {
              if (
                drugStructure[i].forms[j].dosages[k].Value ===
                defaultStructure.dosage
              ) {
                for (
                  let l = 0;
                  j < drugStructure[i].forms[j].dosages[k].quantities.length;
                  l++
                ) {
                  if (
                    drugStructure[i].forms[j].dosages[k].quantities[l].value ===
                    defaultStructure.quantity
                  ) {
                    return drugStructure[i].forms[j].dosages[k].quantities[l]
                      .drug;
                  }
                }
              }
            }
          }
        }
      }
    }
  },

  //function retrun true if value is present in constant form array to display custom qty
  checkIfCustomQtyVisible(formType) {
    return FORMS.some(form => form.toLowerCase() === formType.toLowerCase());
  }
});
